// Integritetspolicy (#324) — structure ours, final wording the client's.
//
// The headings follow what GDPR art. 13 requires a controller to tell a data
// subject at collection time, so the finished text has a slot for each duty
// rather than being written from a blank page.
//
// One section is NOT a placeholder: "Dina rättigheter" describes account
// deletion, which is built and works today — a candidate can erase themselves
// from Kontoinställningar. Stating that is accurate now, so it says so plainly.
import React from 'react';
import { LegalPage, LegalSection, LegalDraftNotice } from './LegalPage';

const PrivacyPage: React.FC = () => (
    <LegalPage
        title="Integritetspolicy"
        intro="Hur Nexilink samlar in, använder och skyddar dina personuppgifter."
    >
        <LegalDraftNotice />

        <LegalSection heading="1. Personuppgiftsansvarig">
            <p>
                Vem som är personuppgiftsansvarig, organisationsnummer, adress och kontaktväg för
                frågor om personuppgifter.
            </p>
        </LegalSection>

        <LegalSection heading="2. Vilka uppgifter vi samlar in">
            <p>
                Uppgifter du själv lämnar: namn, e-post, telefonnummer, CV, profiluppgifter,
                ansökningar och kursresultat. Uppgifter som skapas när du använder tjänsten:
                inloggningar och teknisk information.
            </p>
        </LegalSection>

        <LegalSection heading="3. Varför vi behandlar dem och med vilken rättslig grund">
            <p>
                Ändamål per kategori — att matcha dig mot jobb, att låta arbetsgivare bedöma din
                ansökan, att genomföra introduktion och utbildning — samt den rättsliga grunden för
                varje ändamål (avtal, samtycke eller berättigat intresse).
            </p>
        </LegalSection>

        <LegalSection heading="4. Vem som får ta del av uppgifterna">
            <p>
                Vilka arbetsgivare som ser din profil och när, vilka underleverantörer som anlitas
                (drift, e-post, AI-tjänster) och om uppgifter förs utanför EU/EES.
            </p>
        </LegalSection>

        <LegalSection heading="5. Hur länge vi sparar dem">
            <p>Lagringstider per kategori, och vad som händer med uppgifterna när tiden löpt ut.</p>
        </LegalSection>

        <LegalSection heading="6. Dina rättigheter">
            <p>
                Du har rätt att begära utdrag, rättelse, radering, begränsning och dataportabilitet,
                samt att invända mot viss behandling.
            </p>
            <p>
                <strong>Radera ditt konto.</strong> Det här kan du göra själv och direkt: gå till
                Kontoinställningar och välj <em>Radera konto</em>. Din profil, ditt CV, dina
                ansökningar, dina kursresultat och dina notiser raderas permanent och kan inte
                återställas.
            </p>
            <p>Du har också rätt att lämna klagomål till Integritetsskyddsmyndigheten (IMY).</p>
        </LegalSection>

        <LegalSection heading="7. Cookies">
            <p>Vilka kakor som används, vad de gör och hur du kan påverka dem.</p>
        </LegalSection>

        <LegalSection heading="8. Ändringar och kontakt">
            <p>
                Hur ändringar i policyn meddelas, och vart du vänder dig med frågor om dina
                personuppgifter.
            </p>
        </LegalSection>
    </LegalPage>
);

export default PrivacyPage;
